export default "__VITE_ASSET__jywm66Dn__"